import { Sorter } from "./sorters/Sorter";
import { SorterFactory } from "./sorters/SorterFactory";

export class Sorters
{
  static sortElements( e:Element, elements:Element[] )
  { 
    let sorter = SorterFactory.create( e );

    if ( ! sorter )
    {
      return;
    }
    
    sorter.sortElements( elements );
  }
}